import { render } from "./ServicePayDone.vue?vue&type=template&id=47d9ba48"
import script from "./ServicePayDone.vue?vue&type=script&lang=js"
export * from "./ServicePayDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__